import { render, staticRenderFns } from "./newOrder.vue?vue&type=template&id=fe974602&scoped=true&"
import script from "./newOrder.vue?vue&type=script&lang=js&"
export * from "./newOrder.vue?vue&type=script&lang=js&"
import style0 from "./newOrder.vue?vue&type=style&index=0&id=fe974602&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe974602",
  null
  
)

/* custom blocks */
import block0 from "./newOrder.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports